import React from 'react';
import PropTypes from 'prop-types';
import {getIn} from 'formik';
import TextField from '../components/TextField.jsx';
import formatError, { formatErrorWithIcon } from '../utils/formatError';

const transformField = ({
  disabled,
  field: {onBlur: fieldOnBlur, ...field},
  form: {isSubmitting, touched, errors},
  onBlur,
  helperText,
  FormHelperTextProps,
  ...props
}) => {
  const fieldError = getIn(errors, field.name);
  const showError = getIn(touched, field.name) && !!fieldError;

  const finalHelperTextProps = showError ? {
    ...FormHelperTextProps,
    'role': 'alert',
    'aria-label': formatError( fieldError ),
  } : FormHelperTextProps;

  return {
    error: showError,
    helperText: showError ? formatErrorWithIcon( fieldError ) : helperText,
    FormHelperTextProps: finalHelperTextProps,
    disabled: disabled ?? isSubmitting,
    onBlur:
      onBlur ??
      function(e) {
        fieldOnBlur(e ?? field.name);
      },
    ...field,
    ...props,
  };
};

const NewTextField = ({children, ...props}) => {
  return (
    <TextField
      {...transformField(props)}>
      {children}
    </TextField>);
};

NewTextField.propTypes = {
  children: PropTypes.any,
};

export default NewTextField;
